import http from "../helpers/http-common"

class AnnotationsService {

    saveAnnotation(userId, params) {
        return http.post(`/annotations/${userId}/add`, params);
    }

    getList(userId) {
        return http.get(`/annotations/${userId}/history`)
    }
}

export default new AnnotationsService();